import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import Handler from '../services';
import MyText from './MyText';
import user from "../assets/user.svg";

export default function Selector({ clientList, client, pet, clientChange, petChange, scanned }) {
    // const [selectedClient, setSelectedClient] = useState(client);
    const [selectedPet, setSelectedPet] = useState(pet);
    const handler = Handler();
    const [petList, setPetList] = useState([])

    useEffect(() => {
        // if (!scanned) {
        //     setSelectedPet(null);
        // }
        handler.getPetsOfCustomer(client.id)
            .then(res => {
                let petsArray = res.map(x => {
                    return { "id": x.id, "label": x.name }
                })
                setPetList(petsArray)
            })
            .catch(err => console.log(err))
    }, [])

    // const handleClientChange = (oSelected) => {
    //     setSelectedClient(oSelected ? oSelected : null);
    //     clientChange(oSelected);
    // }
    const handlePetChange = (oSelected) => {
        setSelectedPet(oSelected ? oSelected : null);
        petChange(oSelected);
    }

    return (
        <div style={styles.container}>
            <div style={{ flex: 1 }}>
                <MyText style={styles.myText}>Cliente</MyText>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "end" }}>
                    <div style={{ height: "2rem", marginRight: "1rem" }}>
                        <img src={user} alt="user" />
                    </div>
                    <MyText>{client.label}</MyText>
                </div>
            </div>
            <div style={{ flex: 1 }}>
                <MyText style={styles.myText}>Pet</MyText>
                <Select className='zSelect' placeholder='Seleziona'
                    styles={{
                        option: (base, state) => ({
                            ...base,
                            backgroundColor: 'white !important',
                            color: 'black',
                            borderRadius: '20px',
                        })
                    }}
                    value={selectedPet}
                    onChange={handlePetChange}
                    options={petList}
                />
            </div>
        </div>
    );
}
const styles = {
    container: {
        display: 'flex',
        width: "65%",
        gap: '5%',
    },
    myText: {
        fontSize: '1rem',
        fontFamily: 'Como-Bold',
        marginBottom: '0.5rem',
        // color: "#282d68"
    },
}